import { WBFlex } from '@admiin-com/ds-web';

import { WBDrawer } from '@admiin-com/ds-web';
import { styled, useTheme } from '@mui/material';
import PdfViewer from '../../PdfViewer/PdfViewer';

export const MobileDocumentDrawer = ({
  documentUrl,
  open,
  onClose,
  annotations,
}: {
  documentUrl: string;
  open: boolean;
  onClose: () => void;
  annotations?: any;
}) => {
  const theme = useTheme();
  return (
    <WBDrawer
      anchor={'bottom'}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          overflow: 'auto',
        },
      }}
      sx={{ zIndex: theme.zIndex.drawer + 1 }}
    >
      <PDFPreviewContainer>
        <PdfViewer documentUrl={documentUrl} annotations={annotations} />
      </PDFPreviewContainer>
    </WBDrawer>
  );
};

const PDFPreviewContainer = styled(WBFlex)(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '100%',
  padding: theme.spacing(2),
  minHeight: '500px',
}));
